// @flow

import { dataApiUrl } from 'helpers';

function useApiUrl(app?: string = 'login', tab?: string = 'default'): { baseUrl: string, apiUrl: string } {
  return dataApiUrl(app, tab);
}

export default useApiUrl;
